import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// setOverview (from View) owns persisting the setting, so this toggle and the header pill can't
// drift apart. Seeding from storage happens once where the state lives, not here — this plugin
// only mounts while the plugins strip is open.
const OverviewPlugin = ({ overview, setOverview }) => {
  const { t } = useTranslation();
  function handleToggleOverview() {
    setOverview(!overview);
  }

  return (
    <div className="song-plugin overview-plugin">
      <span className="plugin__title">{t('view.overview')}</span>
      <div className={`plugin__body ${overview ? 'on' : 'off'}`} onClick={handleToggleOverview}>
        <span className="plugin__toggle">{overview ? t('common.on') : t('common.off')}</span>
      </div>
    </div>
  );
};

OverviewPlugin.propTypes = {
  overview: PropTypes.bool,
  setOverview: PropTypes.func,
};

export default OverviewPlugin;
